import React from 'react';
import { Form, Input, Button, Icon, Checkbox, Tooltip } from 'antd';
import { SmartCollectTransaction } from '../../../../models';
import { connect } from 'react-redux';
import { alertify, emailValidationRegex, phoneNumberValidationRegex } from '../../../../app_methods';
import './style';

let CollectRequestForm = (props) => {
    const { form } = props;
    const { getFieldDecorator } = form;
    const validations = SmartCollectTransaction.validations;
    
    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            if (!values.email && !values.phone) {
                alertify("Oops!", "You need to provide either email or phone number.", "error");
                return;
            }
            props.onSubmit(form.getFieldsValue());
        });
    };
    return (
        <Form className={`collect-request-form-wrapper ${props.className}`} onSubmit={onSubmit}>
            <Form.Item label="Phone No." className="mt-3">
                {getFieldDecorator("phone", {
                    rules: [{ pattern: phoneNumberValidationRegex(), message: "Enter valid 10 digit mobile number." }],
                })(<Input autoComplete='off' prefix={<Icon type="phone" />} />)}
            </Form.Item>

            <Form.Item label="Email ID">
                {getFieldDecorator("email", {
                    rules: [{ pattern: emailValidationRegex(), message: "Please enter a valid Email ID." }],
                })(<Input autoComplete='off' prefix={<Icon type="mail" />} />)}
            </Form.Item>

            <Form.Item label="Amount">
                {getFieldDecorator("amount", {
                    rules: validations.amount
                })(<Input autoComplete='off' prefix={<span dangerouslySetInnerHTML={{ __html: `&#8377;` }} />} />)}
            </Form.Item>

            <Form.Item label="Purpose">
                {getFieldDecorator("purpose", {
                     rules:[{ max: 120, message: "Can be of maximum 120 characters" }]
                })(<Input autoComplete='off' prefix={<Icon type="book" />} />)}
            </Form.Item>
            <Form.Item label="Collect Via">
                {getFieldDecorator('collect_request_type', {
                    initialValue: props.virtualAccount.virtual_upi_handle ? ['account_details', 'upi_handle'] : ['account_details'],
                    rules: [{ required: true, message: "Select atleast one." }],
                })(
                    <Checkbox.Group>
                        <Checkbox value="account_details">Account Details    
                            <Tooltip className="ml-1" title={<span>A/c Number: {props.virtualAccount.virtual_account_number} <br/> A/c IFSC: {props.virtualAccount.virtual_ifsc_number}</span>}>
                                <Icon type="info-circle"/>
                            </Tooltip>
                        </Checkbox>
                        <Checkbox value="upi_handle" disabled={props.virtualAccount.virtual_upi_handle ? false: true}>UPI Handle  
                            {props.virtualAccount.virtual_upi_handle ? <Tooltip className="ml-1" title={<span>UPI Handle: {props.virtualAccount.virtual_upi_handle} </span>}>
                                <Icon type="info-circle"/>
                            </Tooltip> : null }
                        </Checkbox>
                    </Checkbox.Group>
                )}
            </Form.Item>
            <div className="row mt-3">
                <div className="col-sm">
                    <div className="font-weight-bold" style={{ color: "#58666e" }}>Note:</div>
                    <i>Collect request would be sent via email & SMS with payment instructions.</i>
                </div>
            </div>

            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Send Collect Request</Button>
            </div>
        </Form>

    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

CollectRequestForm = Form.create()(CollectRequestForm);

export default connect(mapStateToProps)(CollectRequestForm);